import styles from './styles.module.css';

export const styleButtonHoverable = styles.hoverableButton;

export const styleButtonSquare = `${styles.hoverableButton} ${styles.squareButton}`;

export const styleButtonRounded = `${styles.hoverableButton} ${styles.roundedButton}`;

export const styleBlockFullWidth = styles.blockFullWidth;

export const styleBlockFullWidthPadded = styles.blockFullWidthPadded;

export const styleBlockSmall = styles.blockSmall;

export const styleBlockSmallExpandRight = styles.blockSmallExpandRight;

export const styleBlockMedium = styles.blockMedium;

export const styleBlockLarge = styles.blockLarge;

export const styleLayout = styles.layout;

export const styleBlockSmallMarginLeft = styles.blockSmallMarginLeft;
